<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="usersRoles.usersRoles"
      :no-data-text="$t('extraRides.noDataAvailable')"
      :footer-props="{
        itemsPerPageOptions: [-1, 5, 20],
        itemsPerPageText: $t('general.rowsPerPage'),
        itemsPerPageAllText: $t('dataTable.allRows'),
      }"
    >
      <template #body="{ items }">
        <tbody>
          <tr
            v-for="(userRoles, userRolesIndex) in items"
            :key="userRolesIndex"
          >
            <!-- user name -->
            <td>
              {{ userRoles.getFullName() }}
            </td>

            <!-- roles -->
            <td>
              <v-row>
                <!-- iterate available roles -->
                <v-col
                  v-for="(
                    availableRole, availableRoleIndex
                  ) in availableRoles.roles"
                  :key="availableRoleIndex"
                  class="col-3 py-0"
                >
                  <v-checkbox
                    :input-value="userRoles.hasRole(availableRole)"
                    :label="availableRole.name"
                    @change="flipRole(availableRole, userRoles)"
                  />
                </v-col>
              </v-row>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- add new user -->
    <v-row>
      <v-col class="col-12 headline-standard">
        {{ $t('roleManagement.addNewRole') }}
      </v-col>
      <v-col class="col-5 pl-0">
        <booking-by-customer-search
          booking-mode="hidden"
          capture-user
          :selectedUserBookings.sync="newUser"
        />
      </v-col>
      <v-col v-if="newUser" class="col-7">
        <!-- new user already in list above -->
        <v-row v-if="usersRoles.hasUser(newUser.getId())">
          <v-col class="col-12 mt-4 content-2">
            <span class="fal fa-hand-point-up mr-2" />
            {{ $t('roleManagement.userAlreadyAdded') }}
          </v-col>
        </v-row>

        <v-row v-else>
          <!-- iterate available roles -->
          <v-col
            v-for="(newRole, newRoleIndex) in availableRoles.roles"
            :key="newRoleIndex"
            class="col-4"
          >
            <v-checkbox :label="newRole.name" @change="linkNewUser(newRole)" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UsersRoles from '../../classes-shared/roles/UsersRoles'
import Roles from '../../classes-shared/roles/Roles'
import SearchUserAutocomplete from '../booking/SearchUserAutocomplete'
import BookingByCustomerSearch from '../booking/BookingByCustomerSearch'
import UserRoles from '../../classes-shared/roles/UserRoles'

export default {
  name: 'RoleManagement',
  components: { BookingByCustomerSearch },
  data() {
    return {
      usersRoles: new UsersRoles(),
      availableRoles: new Roles(),
      newUser: null,
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('roleManagement.user'),
          sortable: true,
          value: 'firstName',
        },
        {
          text: this.$t('roleManagement.role'),
          sortable: false,
        },
      ]
    },
  },

  beforeMount() {
    // initial api fetching
    this.init()
  },

  methods: {
    // initial component loadings
    async init() {
      this.newUser = null
      await this.usersRoles.loadUsersRoles()
      await this.availableRoles.loadAvailableRolesForRegion()
    },

    async flipRole(availableRole, userRoles) {
      await userRoles.flipRole(availableRole, userRoles.getId())
      await this.usersRoles.loadUsersRoles()
    },

    async linkNewUser(role) {
      let userRole = new UserRoles({})
      if (await userRole.linkRole(role.id, this.newUser.getId())) {
        // reload component
        await this.init()
      }
    },
  },
}
</script>
